var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34.0002,
    r: 24,
    transform: "rotate(45 34 34.0002)",
    fill: "#89939E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1213 20.5656C35.9404 20.3846 35.6903 20.2724 35.4142 20.2728H32.5858C32.0328 20.2728 31.5852 20.7204 31.5859 21.2727L31.5859 31.5865L21.2721 31.5865C20.7191 31.5865 20.2715 32.0341 20.2722 32.5864V35.4148C20.2722 35.9678 20.7198 36.4154 21.2721 36.4147L31.5859 36.4147V46.7285C31.5852 47.2808 32.0335 47.7291 32.5858 47.7284H35.4142C35.9672 47.7284 36.4148 47.2808 36.4141 46.7285V36.4147L46.7279 36.4147C47.2802 36.4154 47.7285 35.9671 47.7278 35.4148V32.5864C47.7278 32.0334 47.2802 31.5858 46.7279 31.5865L36.4141 31.5865L36.4141 21.2727C36.4141 20.9962 36.3023 20.7465 36.1213 20.5656Z",
    fill: "#F5F5F7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleIcon);
export default __webpack_public_path__ + "static/media/toggle-icon.100bb9fb442ade334d7e2694d49f105d.svg";
export { ForwardRef as ReactComponent };